/**
 * MATAFOME — API DE AUTENTICAÇÃO E RECUPERAÇÃO DE ACESSO
 */

import { safeApiFetch, saveSession, getApiBase } from './core.api';

export async function loginWithKey(accessKey) {
    const res = await safeApiFetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ accessKey })
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Falha ao autenticar.');
    saveSession(data.token, data.store, data.user);
    return data;
}

export async function loginWithEmail(email, password) {
    const res = await safeApiFetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'E-mail ou senha inválidos.');
    saveSession(data.token, data.store, data.user);
    return data;
}

export async function requestPasswordReset(email) {
    const res = await safeApiFetch('/api/auth/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Não foi possível solicitar a recuperação de senha.');
    return data;
}

export async function resetPasswordWithToken(token, password) {
    const res = await safeApiFetch('/api/auth/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password })
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Não foi possível redefinir a senha.');
    return data;
}

// ----------------------------------------------------
// CARDÁPIO & CATEGORIAS
// ----------------------------------------------------
